export default __webpack_public_path__ + "static/mp_open_house_2018_1-dc7041631418b8d2c4d59e8b06f0f47d.jpg";